module.exports = __webpack_public_path__ + "fonts/GothamProMedium.woff";